/* eslint-disable @typescript-eslint/no-explicit-any */
import {defaultErrorValues} from '../../data/constants/Assurance/assuranceRCVP';
import {IError} from '../../data/types/interface/Assurance/assuranceRCVP';
import {MAIL_VALIDATION, MESSAGE_VALIDATION} from './validation';

export const Validation = (values: IError, listAgence?: []) => {
  let errors: IError = {...defaultErrorValues};

  /** mail checking */

  if (!MAIL_VALIDATION.test(values.emailContractant)) {
    errors.emailContractant = MESSAGE_VALIDATION.requiredEmail;
  }

  /** agence cheking */

  if (values.agence !== '') {
    const _list = listAgence && [...listAgence];
    const _data =
      _list &&
      _list.filter(
        (item: any) =>
          item.label.toLowerCase().indexOf(values.agence.toLowerCase()) > -1,
      );
    const _agence =
      _list && _list.filter((item: any) => item.label === values.agence);

    if ((_data && _data.length === 0) || _agence?.length === 0) {
      errors.agence = MESSAGE_VALIDATION.invalidAgence;
    }
  }

  /** telphone cheking */

  if (!/^0\d{9}$/g.test(values.telephoneContractant)) {
    errors.telephoneContractant = MESSAGE_VALIDATION.requiredTelephone;
  }

  /** date de naissance checking */

  if (values.dateNaissanceContractant !== '') {
    const _ageMin = 21;
    const _date = new Date(values.dateNaissanceContractant);
    const minDate = new Date();
    minDate.setFullYear(new Date().getFullYear() - _ageMin);
    if (_date >= minDate) {
      errors.dateNaissanceContractant = `L'âge minimum valide est de ${_ageMin} ans`;
    }
  }

  /** checking all values */

  Object.entries(values).forEach(element => {
    if (
      element[0] !== 'telephoneContractantCountryCode' &&
      (element[1] === '' || element[1] === null)
    ) {
      errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
    }
  });

  return errors;
};
